import { Avatar, Box, Button, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from '@mui/material';
import { Close, Logout } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { ITicketChat, STATUS_CHAT } from '../../../interfaces/chat.ts';
import { Dispatch, useContext } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../contexts/UserContext.tsx';
import { getInitials } from '../../../utils/string.ts';

export default function ChatLayout({ closeLayout, audience, setAudience, id }: { closeLayout: () => void; audience?: ITicketChat; setAudience: Dispatch<React.SetStateAction<ITicketChat | undefined>>; id: number }) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { user } = useContext(UserContext);

	const closeChat = () => {
		axios({
			url: user?.is_admin ? `/admin/tickets/close/${id}` : `/tickets/close/${id}`,
			method: 'POST',
		}).then(r => {
			if (r?.data?.success) {
				if (audience !== undefined) {
					setAudience({ ...audience, status: STATUS_CHAT.Closed });
					navigate(-1);
				}
			}
		});
	};

	return (
		<Box className={'h-full w-full overflow-y-auto'}>
			<Box className={'h-full w-full'}>
				<Box>
					<IconButton onClick={closeLayout}>
						<Close />
					</IconButton>
				</Box>

				<Box className="flex flex-col items-center gap-6">
					<Avatar alt="avatar" src={user?.image ?? ''} className="ml-2 h-16 w-16">
						{getInitials(user?.name!)}
					</Avatar>
					<Typography className={'mb-2 text-lg font-medium'}>{user?.name}</Typography>
					<TableContainer component={Paper}>
						<Table>
							<TableBody>
								<TableRow>
									<TableCell>{t('ticket_title')}</TableCell>
									<TableCell>{audience?.title}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>{t('company-name')}</TableCell>
									<TableCell>{audience?.company}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>{t('department-id')}</TableCell>
									<TableCell>{audience?.department_id}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>{t('status')}</TableCell>
									<TableCell>{t(audience?.status ?? '')}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>{t('create-date')}</TableCell>
									<TableCell>{new Date(audience?.created_at ?? '').toLocaleDateString('fa-IR')}</TableCell>
								</TableRow>
								<TableRow>
									<TableCell>{t('updated_at')}</TableCell>
									<TableCell>{new Date(audience?.updated_at ?? '').toLocaleDateString('fa-IR')}</TableCell>
								</TableRow>
							</TableBody>
						</Table>
					</TableContainer>
					{audience?.status !== STATUS_CHAT.Closed && (
						<Button fullWidth variant={'contained'} startIcon={<Logout />} className={'py-3'} onClick={closeChat}>
							{t('close_ticket')}
						</Button>
					)}
				</Box>
			</Box>
		</Box>
	);
}
